// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextAreaProps } from "@conklin/MobiusOverrides/TextArea/TextArea";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextArea from "@insite/mobius/TextArea";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqConfirmation.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqConfirmationNotesStyles {
    notesTextArea?: TextAreaProps;
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    noteWrapper?: InjectableCss;
}

export const rfqConfirmationNotesStyles: RfqConfirmationNotesStyles = {};

const styles = rfqConfirmationNotesStyles;

const RfqConfirmationNotes: FC<Props> = ({ quoteState }) => {
    if (!quoteState.value || !quoteState.value?.notes) {
        return null;
    }

    const quote = quoteState.value;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.title}>{translate("Quote Request Summary")}</Typography>
            <TextArea label={translate("Order Note (Optional)")} disabled={true} {...styles.notesTextArea}>
                {quote.notes}
            </TextArea>
            <StyledWrapper {...styles.noteWrapper}>{quote.notes}</StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqConfirmationNotes),
    definition: {
        displayName: "RFQ Quote Confirmation Note",
        allowedContexts: ["RfqConfirmationPage"],
        fieldDefinitions: [],
        group: "RFQ Quote Confirmation",
    },
};

export default widgetModule;
